import type { FC } from 'react'

import { cn } from '@/lib/utils'

interface LogoProps {
    className?: string
    /** Hide the "himelio" word and show only the receipt mark. */
    markOnly?: boolean
    tone?: 'ink' | 'cream'
}

/** The Himelio receipt mark: a printed ticket with an H cut out of it and a live signal dot. */
export const LogoMark: FC<{ className?: string, tone?: 'ink' | 'cream' }> = ({ className, tone = 'ink' }) => {
    const paper = tone === 'ink' ? 'var(--ink, #f4f3ee)' : 'var(--cream, #262624)'
    const cut = tone === 'ink' ? 'var(--cream, #262624)' : 'var(--ink, #f4f3ee)'

    return (
        <svg
            aria-hidden='true'
            viewBox='0 0 32 32'
            className={cn('shrink-0', className)}
        >
            <path
                d='M7 2.5h18a3 3 0 0 1 3 3V28l-3-2-3 2-3-2-3 2-3-2-3 2-3-2-3 2V5.5a3 3 0 0 1 3-3Z'
                fill={paper}
            />
            <path
                d='M10 8.5h3.6v5.4h4.8V8.5H22v14h-3.6v-5.2h-4.8v5.2H10z'
                fill={cut}
            />
            <circle
                cx='26.5'
                cy='4'
                r='3.2'
                fill='var(--ember, #ffffff)'
                stroke={cut}
                strokeWidth='1.4'
            />
        </svg>
    )
}

export const Logo: FC<LogoProps> = ({ className, markOnly = false, tone = 'ink' }) => {
    return (
        <span className={cn('inline-flex items-center gap-[0.32em] leading-none', tone === 'ink' ? 'text-ink' : 'text-cream', className)}>
            <LogoMark
                tone={tone}
                className='size-[1.15em]'
            />
            {!markOnly && (
                <span className='font-heading font-bold lowercase tracking-[-0.045em]'>
                    himelio
                </span>
            )}
        </span>
    )
}
